module.exports = __webpack_public_path__ + "static/media/bible.50264116.svg";